import { t } from '@lingui/macro';
import CollectionModal from 'modals/CollectionModal/CollectionModal';
import { useCollectionModalContext } from 'modals/CollectionModal/CollectionModalContext';
import { ModalProps } from 'modals/Modal.types';
import React, { useMemo } from 'react';
import { ModalsEnum } from 'types/enums';

const CreateCollectionModal: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
}) => {
    const { samplesToAdd } = useCollectionModalContext();

    const sampleIds = useMemo(() => {
        return samplesToAdd.map((samples) => samples?.guid) || [];
    }, [samplesToAdd]);

    return (
        <CollectionModal
            title={t`New collection`}
            submitButtonText={t`Create`}
            modalType={ModalsEnum.createCollectionModal}
            sampleIds={sampleIds}
            handleClose={handleClose}
            isOpen={isOpen}
        />
    );
};

export default CreateCollectionModal;
